module.exports = __webpack_public_path__ + "img/m_top_happytablet.1890ed5f.jpg";